import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/_services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-bill-to',
  templateUrl: './add-bill-to.component.html',
  styleUrls: ['./add-bill-to.component.css']
})
export class AddBillToComponent implements OnInit {
  PlaceOrderCustomer:[];
  IEditPayorId=0
FormPayorAdd:FormGroup;
  constructor(private _httpClient:HttpClient,
    private FormBuilder:FormBuilder,
    private authenticationService:AuthenticationService,
    public dialogRef: MatDialogRef<AddBillToComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.PlaceOrderCustomer=[];
    this.OnSelectCostumer();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.FormPayorAdd=this.FormBuilder.group(
      {
        PayorId:["",Validators.required]
      }
    )
    this.Oncustomerpayordefaultselect(this.data,1)
  }


OnAddPayorId(){

  this._httpClient
  .get<any>(
    `${environment.apiUrl}/Customer/PayorAddCustomer?tipo=${Number(this.IEditPayorId)}&tbl_customerID=${Number(this.data)}&payorID=${Number(this.FormPayorAdd.controls.PayorId.value)}&type_access=1&active=1`,
   
    {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'Access-Control-Allow-Methods': '*',
        Authorization: 'Bearer ' + this.authenticationService.currentUserValue.token
      })
    }
  )
  .subscribe((response: any) => {
this.onNoClick();

  });

}

OnSelectCostumer() {
  var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario

  var Request = {};
  Request['companyId'] = json.companyIdWh;
  Request['active'] = '1';

  this._httpClient
  .post<any>(`${environment.apiUrl}/Shipping/SelectBillCustomer`, Request, {
    headers: new HttpHeaders({
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': '*',
    'Access-Control-Allow-Methods': '*',
    Authorization: 'Bearer ' + json.token,
    }),
  })
  .subscribe((response: any) => {
    this.PlaceOrderCustomer = response;
  });
}

Oncustomerpayordefaultselect(Id:any,type:any) {
  var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario


  this._httpClient
  .get<any>(`${environment.apiUrl}/Customer/customerpayordefaultselect?Id=${Number(Id)}&type=${Number(type)}`, {
    headers: new HttpHeaders({
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': '*',
    'Access-Control-Allow-Methods': '*',
    Authorization: 'Bearer ' + json.token,
    }),
  })
  .subscribe((response: any) => {

try {
  this.IEditPayorId = response[0].id_payor_default;

} catch (error) {
  this.IEditPayorId=0;
}


  });
}

}
